const transformTo64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

const getBase64 = async(file) => {
    const file64 = await transformTo64(file);
    const fileHeader = 'base64,';
    return file64.split(fileHeader)[1];
};

export default getBase64;